sew-ws-locale-switch {
    display: block;

    .headline {
        @include typo-ws-h3;

        margin: 8px 16px 0 0;
    }

    sew-ws-richtext {
        margin-top: 32px;

        p:last-of-type {
            margin-bottom: 0;
        }
    }

    sew-ws-button {
        margin-top: 40px;
        width: 100%;
    }

    sew-ws-show-more {
        margin-top: 12px;
    }

    sew-combobox {
        margin-top: 24px;

        &:last-of-type {
            margin-top: 32px;
        }

        + sew-combobox:last-of-type {
            margin-top: 24px;
        }
    }

    .error {
        @include typo-ws-paragraph;

        margin: 40px -32px -40px;
        background-color: $color-red;
        color: $color-white;
        display: flex;
        padding: 12px 32px;
        column-gap: 20px;
        align-items: center;

        sew-icon {
            width: 28px;
            flex-shrink: 0;
        }
    }
}
